<template>
  <div>
    <template v-if="currentTrack">
      <h1 class="is-size-7 is-uppercase">Playing now</h1><hr>

      <player-queue-track
        v-bind:track="currentTrack"
        v-on:cover-click="togglePlay"
      />
    </template>

    <template v-if="nextTracks.length">
      <h1 class="is-size-7 is-uppercase">Next tracks</h1><hr>

      <div class="columns is-multiline">
        <div v-for="(track, index) in nextTracks" v-bind:key="track.id" class="column is-12">
          <player-queue-track
            v-bind:track="track"
            v-on:cover-click="playTrack(index + 1)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import PlayerQueueTrack from '@/components/PlayerQueueTrack'

  export default  {
    name: 'PlayerQueue',
    components: {
      PlayerQueueTrack
    },
    computed: {
      currentTrack: function () {
        return this.$store.getters.currentTrack
      },
      nextTracks: function () {
        return this.$store.getters.nextTracks
      }
    },
    methods: {
      togglePlay: function () {
        this.$store.commit('togglePlay')
      },
      playTrack: function (trackIndex) {
        this.$store.commit('playTrackIndex', {
          trackIndex: this.$store.getters.currentTrackIndex + trackIndex
        })
      }
    }
  }
</script>
